<template>
	<v-container grid-list-xl fluid>
		<v-layout row wrap>
			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.farmOwner')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{$t('farm.farmOwner')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.farmOwner || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>

				<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.govRegistrationNo')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{$t('farm.govRegistrationNo')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.govRegistrationNum || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>

			

			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.ownershipType')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{$t('farm.ownershipTypeState')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.farmOwnershipType || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<!-- <v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.contractMating')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
										<v-icon v-bind="attrs" v-on="on">
											mdi-help-circle-outline
										</v-icon>
										</template>
										<span>{{$t('farm.contractMatingState')}}
										</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.contractMating || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
      		</v-flex> -->
			<!-- <v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.productionSystem')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{$t('farm.productionSystemState')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ (farmProductionSystem.length > 0 && farmProductionSystem.map(item => item.name).join(' , ')) || "N/A"}}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex> -->

			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.cooperativeID')}}
									<v-tooltip left color="black" max-width="350">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>This field only applies to you if you belong to any cooperative ( A cooperative is an autonomous association of persons united voluntarily to meet their common economic, social and cultural needs and aspirations through a jointly-owned and democratically-controlled enterprise). IF you belong to a cooperative, please indicate the unique identifier of that cooperative, it can be a registrration or license number uniquely identifying the cooperative you associate with.</span>

									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.cooperativeId || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>

			
			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.cooperativeName')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{$t('farm.cooperativeName')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.cooperativeName || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			
			
		</v-layout>
	</v-container>
</template>
<script>
// import { mapGetters } from "vuex";
import FarmService from "@/_services/farmService";

export default {
	name: "Information",
	data() {
		return {
			farmProductionSystems: [],
			farmProductionSystem: [],
		}
	},
	computed: {
		// ...mapGetters(["getfarm"]),
	},
	props: {
		farm: {
			require: true
		}
	},
	async mounted() {
		const options = await FarmService.getFarmOptions();
		this.farmProductionSystems = options.FarmProductionSystem;
		let productionSystem = typeof JSON.parse(this.$props.farm.productionSystem) === 'object' ?
		JSON.parse(this.$props.farm.productionSystem): [JSON.parse(this.$props.farm.productionSystem)]
		this.farmProductionSystem = this.farmProductionSystems.filter(item => productionSystem.some(i => i === item.id));
	}
};
</script>
<style lang="scss" scoped>
.flex.lg5-custom {
	width: 20%;
	max-width: 80%;
	flex-basis: 20%;
}
</style>